(function () {
  "use strict";

  var GATE_KEY = "theartfolio_studio_gate";
  var VIEW_KEY = "theartfolio_studio_viewed";
  var CLICK_KEY = "theartfolio_studio_clicked";

  function theme() {
    return window.theme || {};
  }

  function proxyPath() {
    var path = theme().followProxyPath || "/apps/artfolio";
    return String(path).replace(/\/$/, "");
  }

  function isLoggedIn() {
    return Boolean(theme().customerId) || theme().loggedIn === true;
  }

  function request(path, options) {
    return fetch(proxyPath() + path, Object.assign({
      credentials: "same-origin",
      headers: { accept: "application/json" }
    }, options || {})).then(function (res) {
      return res.json().catch(function () {
        return {};
      }).then(function (body) {
        body = body || {};
        body.status = res.status;
        body.ok = res.ok;
        return body;
      });
    }).catch(function () {
      return { ok: false, status: 0 };
    });
  }

  function readJson(key, fallback) {
    try {
      var parsed = JSON.parse(sessionStorage.getItem(key) || "null");
      return parsed && typeof parsed === "object" ? parsed : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function writeJson(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {}
  }

  function fmtInt(value) {
    var n = Math.round(Number(value) || 0);
    return n.toLocaleString("en-GB");
  }

  function fmtGbp(value) {
    var n = Number(value) || 0;
    return "£" + n.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function fmtPct(value) {
    var n = (Number(value) || 0) * 100;
    if (n > 0 && n < 1) return "<1%";
    return Math.round(n) + "%";
  }

  function titleize(handle) {
    return String(handle || "")
      .replace(/-/g, " ")
      .replace(/\b\w/g, function (c) {
        return c.toUpperCase();
      });
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (char) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char];
    });
  }

  function safeImage(url) {
    var s = String(url || "");
    if (!/^https:\/\//i.test(s)) return "";
    return s.replace(/"/g, "");
  }

  function collectionFromPath() {
    var match = window.location.pathname.match(/^\/collections\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : "";
  }

  function londonDay() {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: "Europe/London",
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    }).format(new Date());
  }

  function sendEvent(payload) {
    return request("/events", {
      method: "POST",
      keepalive: true,
      headers: { accept: "application/json", "content-type": "application/json" },
      body: JSON.stringify(payload)
    });
  }

  function markOnce(store, key) {
    if (store[key]) return false;
    store[key] = 1;
    return true;
  }

  function hydrateHeader() {
    var links = document.querySelectorAll("[data-studio-nav]");
    if (!links.length || !isLoggedIn()) return;

    var cached = readJson(GATE_KEY, null);
    if (cached && typeof cached.isArtist === "boolean" && Date.now() - (cached.ts || 0) < 5 * 60 * 1000) {
      if (cached.isArtist) {
        links.forEach(function (el) {
          el.hidden = false;
        });
      }
      return;
    }

    request("/studio?probe=1").then(function (body) {
      var isArtist = Boolean(body && body.isArtist);
      writeJson(GATE_KEY, { isArtist: isArtist, ts: Date.now() });
      if (!isArtist) return;
      links.forEach(function (el) {
        el.hidden = false;
      });
    });
  }

  function bindBeacons() {
    var viewed = readJson(VIEW_KEY, {});
    var clicked = readJson(CLICK_KEY, {});
    var day = londonDay();
    var col = collectionFromPath();

    if (document.body.classList.contains("template-product")) {
      var product = document.querySelector("[data-product-handle]");
      var handle = product && (product.getAttribute("data-product-handle") || "").trim().toLowerCase();
      var viewKey = day + ":view:" + handle;
      if (handle && markOnce(viewed, viewKey)) {
        writeJson(VIEW_KEY, viewed);
        sendEvent({ kind: "view", handle: handle, collection: col });
      }
    }

    if (document.body.classList.contains("template-collection") && col) {
      var colKey = day + ":col:" + col;
      if (markOnce(viewed, colKey)) {
        writeJson(VIEW_KEY, viewed);
        sendEvent({ kind: "collection_view", collection: col });
      }
    }

    document.addEventListener("click", function (event) {
      if (event.target.closest(".card-explore-link, .card-enlarge, .reaction-button, [data-find-similar], [data-discover-remix-card], [data-coll-enlarge], .taste-shelf-remix")) {
        return;
      }
      var card = event.target.closest("[data-studio-handle], [data-work-handle], a[href*='/products/']");
      if (!card) return;
      var handle = (card.getAttribute("data-studio-handle") || card.getAttribute("data-work-handle") || "").trim().toLowerCase();
      if (!handle) {
        var href = card.getAttribute("href") || "";
        var match = href.match(/\/products\/([^/?#]+)/i);
        if (match) handle = decodeURIComponent(match[1]).toLowerCase();
      }
      if (!handle) return;
      var fromCol = (card.getAttribute("data-studio-collection") || col || "").trim().toLowerCase();
      var clickKey = day + ":click:" + handle;
      if (!markOnce(clicked, clickKey)) return;
      writeJson(CLICK_KEY, clicked);
      sendEvent({ kind: "click", handle: handle, collection: fromCol });
    }, true);

    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      var root = form.closest("[data-product-handle]") || document.querySelector("[data-product-handle]");
      var handle = root && (root.getAttribute("data-product-handle") || "").trim().toLowerCase();
      if (!handle) return;
      sendEvent({ kind: "add_to_cart", handle: handle, collection: col });
    }, true);
  }

  function emptyList(el, message) {
    el.innerHTML = "";
    var li = document.createElement("li");
    li.className = "studio-empty";
    li.textContent = message;
    el.appendChild(li);
  }

  function fillRank(el, rows, hrefFn, labelFn, valueFn, emptyMessage) {
    el.innerHTML = "";
    if (!rows || !rows.length) {
      emptyList(el, emptyMessage);
      return;
    }
    rows.forEach(function (row) {
      var li = document.createElement("li");
      var a = document.createElement("a");
      a.href = hrefFn(row);
      a.textContent = labelFn(row);
      var b = document.createElement("b");
      b.textContent = valueFn(row);
      li.appendChild(a);
      li.appendChild(b);
      el.appendChild(li);
    });
  }

  function fmtWhen(value) {
    var d = new Date(value);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  }

  function renderCommissions(root, rows) {
    var list = root.querySelector("[data-studio-commissions]");
    var countEl = root.querySelector("[data-studio-commission-count]");
    if (!list) return;
    var items = Array.isArray(rows) ? rows : [];
    if (countEl) countEl.textContent = items.length ? items.length + (items.length === 1 ? " note" : " notes") : "";
    list.innerHTML = "";
    if (!items.length) {
      var empty = document.createElement("p");
      empty.className = "studio-empty";
      empty.textContent = "No commission notes yet. They appear here when someone writes from your page.";
      list.appendChild(empty);
      return;
    }
    items.forEach(function (row) {
      var article = document.createElement("article");
      article.className = "studio-enquiry";
      var bits = [];
      if (row.phone) bits.push("Tel " + row.phone);
      if (row.location) bits.push(row.location);
      if (row.size_note) bits.push(row.size_note);
      if (row.budget) bits.push("Budget " + row.budget);
      article.innerHTML =
        "<header>" +
        "<strong>" + escapeHtml(row.name) + "</strong>" +
        '<a href="mailto:' + escapeHtml(row.email) + '">' + escapeHtml(row.email) + "</a>" +
        "<time>" + escapeHtml(fmtWhen(row.created_at)) + "</time>" +
        "</header>" +
        (bits.length ? '<p class="studio-enquiry-meta">' + escapeHtml(bits.join(" · ")) + "</p>" : "") +
        "<p>" + escapeHtml(row.message) + "</p>";
      list.appendChild(article);
    });
  }

  function renderHang(root, works) {
    var el = root.querySelector("[data-studio-hang]");
    if (!el) return;
    var pinned = Array.isArray(root._pinned) ? root._pinned : [];
    var byHandle = {};
    (works || []).forEach(function (work) {
      byHandle[String(work.handle || "").toLowerCase()] = work;
    });
    el.innerHTML = "";
    if (!pinned.length) {
      emptyList(el, "Pin up to three works in the table. They open your public page.");
      return;
    }
    pinned.forEach(function (handle, index) {
      var work = byHandle[handle] || { handle: handle, title: handle };
      var li = document.createElement("li");
      var img = safeImage(work.image_url)
        ? '<img src="' + safeImage(work.image_url) + '" alt="' + escapeHtml(work.title || "Artwork") + '" width="44" height="44">'
        : "";
      li.innerHTML =
        '<b>' + (index + 1) + "</b>" +
        '<a class="studio-work" href="/products/' + encodeURIComponent(work.handle) + '">' +
        img + "<span>" + escapeHtml(work.title || work.handle) + "</span></a>";
      el.appendChild(li);
    });
  }

  function renderDash(root, data, sortKey) {
    var artist = data.artist || {};
    var totals = data.totals || {};
    var site = data.site || {};
    var pinned = Array.isArray(root._pinned) ? root._pinned : (data.pinned || []);
    root._pinned = pinned.slice(0, 3);
    var works = (data.works || []).slice();
    works.sort(function (a, b) {
      if (sortKey === "orders") return (b.orders || 0) - (a.orders || 0) || (b.views || 0) - (a.views || 0);
      return (b.views || 0) - (a.views || 0) || (b.orders || 0) - (a.orders || 0);
    });

    var artistEl = root.querySelector("[data-studio-artist]");
    if (artistEl) {
      artistEl.textContent = artist.display_name || "Studio";
    }

    var pageLink = root.querySelector("[data-studio-page]");
    if (pageLink && artist.page_url) {
      pageLink.href = artist.page_url;
      pageLink.hidden = false;
    }

    var cards = root.querySelector("[data-studio-cards]");
    if (cards) {
      var commissions = Array.isArray(data.commissions) ? data.commissions : [];
      cards.innerHTML =
        '<article class="studio-card"><span>Views</span><strong>' + fmtInt(totals.views) + "</strong></article>" +
        '<article class="studio-card"><span>Clicks</span><strong>' + fmtInt(totals.clicks) + "</strong></article>" +
        '<article class="studio-card"><span>Orders</span><strong>' + fmtInt(totals.orders) + "</strong></article>" +
        '<article class="studio-card"><span>Followers</span><strong>' + fmtInt(artist.followers) + "</strong></article>" +
        '<article class="studio-card"><span>Enquiries</span><strong>' + fmtInt(commissions.length) + "</strong></article>";
    }

    renderHang(root, works);
    renderCommissions(root, data.commissions);

    var tbody = root.querySelector("[data-studio-works]");
    if (tbody) {
      tbody.innerHTML = "";
      if (!works.length) {
        var tr = document.createElement("tr");
        tr.innerHTML = '<td colspan="6"><p class="studio-empty">No works linked yet. Catalogue sync may still be running.</p></td>';
        tbody.appendChild(tr);
      } else {
        var full = root._pinned.length >= 3;
        works.forEach(function (work) {
          var handle = String(work.handle || "").toLowerCase();
          var pinAt = root._pinned.indexOf(handle);
          var on = pinAt >= 0;
          var row = document.createElement("tr");
          var img = safeImage(work.image_url)
            ? '<img src="' + safeImage(work.image_url) + '" alt="' + escapeHtml(work.title || "Artwork") + '" width="44" height="44">'
            : "";
          row.innerHTML =
            '<td><button type="button" class="studio-chip studio-pin' + (on ? " is-on" : "") +
            '" data-studio-pin="' + escapeHtml(handle) + '" aria-pressed="' + (on ? "true" : "false") + '"' +
            (full && !on ? " disabled" : "") + ">" +
            (on ? String(pinAt + 1) : "Pin") + "</button></td>" +
            '<td><a class="studio-work" href="/products/' + encodeURIComponent(work.handle) + '">' +
            img + "<span>" + escapeHtml(work.title || work.handle) + "</span></a></td>" +
            "<td>" + fmtInt(work.views) + "</td>" +
            "<td>" + fmtInt(work.clicks) + "</td>" +
            "<td>" + fmtInt(work.orders) + "</td>" +
            "<td>" + fmtGbp(work.revenue_gbp) + "</td>";
          tbody.appendChild(row);
        });
      }
    }

    fillRank(
      root.querySelector("[data-studio-quiet]"),
      data.quiet,
      function (row) { return "/products/" + encodeURIComponent(row.handle); },
      function (row) { return row.title || row.handle; },
      function (row) { return fmtInt(row.views) + " views"; },
      "Not enough views yet to spot quiet works."
    );

    var share = root.querySelector("[data-studio-share]");
    if (share) {
      share.textContent = site.views
        ? fmtPct(site.your_share) + " of site views this period."
        : "Site-wide views will appear here once people browse.";
    }

    fillRank(
      root.querySelector("[data-studio-collections]"),
      site.top_collections,
      function (row) { return "/collections/" + encodeURIComponent(row.handle); },
      function (row) { return titleize(row.handle); },
      function (row) { return fmtInt(row.views) + " views"; },
      "No collection views yet."
    );

    fillRank(
      root.querySelector("[data-studio-site-works]"),
      site.top_works,
      function (row) { return "/products/" + encodeURIComponent(row.handle); },
      function (row) { return row.title || row.handle; },
      function (row) { return fmtInt(row.views) + " views"; },
      "No site-wide work views yet."
    );
  }

  function bindDash() {
    var root = document.querySelector("[data-studio-app]");
    if (!root) return;

    var status = root.querySelector("[data-studio-status]");
    var denied = root.querySelector("[data-studio-denied]");
    var dash = root.querySelector("[data-studio-dash]");
    var sortKey = "views";
    var query = "range=30";

    function setStatus(text) {
      if (status) status.textContent = text || "";
    }

    function load() {
      setStatus("Loading your studio…");
      return request("/studio?" + query).then(function (body) {
        if (!body || !body.ok) {
          setStatus("Studio could not load just now.");
          return;
        }
        if (!body.isArtist) {
          setStatus("");
          if (denied) denied.hidden = false;
          if (dash) dash.hidden = true;
          writeJson(GATE_KEY, { isArtist: false, ts: Date.now() });
          return;
        }
        writeJson(GATE_KEY, { isArtist: true, ts: Date.now() });
        if (denied) denied.hidden = true;
        if (dash) dash.hidden = false;
        setStatus(body.range ? body.range.from + " → " + body.range.to : "");
        root._pinned = Array.isArray(body.pinned) ? body.pinned.slice(0, 3) : [];
        root._data = body;
        renderDash(root, body, sortKey);
      });
    }

    root.querySelectorAll("[data-studio-range]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.querySelectorAll("[data-studio-range]").forEach(function (el) {
          el.classList.toggle("is-on", el === btn);
        });
        query = "range=" + encodeURIComponent(btn.getAttribute("data-studio-range") || "30");
        load();
      });
    });

    root.querySelectorAll("[data-studio-sort]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        sortKey = btn.getAttribute("data-studio-sort") || "views";
        root.querySelectorAll("[data-studio-sort]").forEach(function (el) {
          el.classList.toggle("is-on", el === btn);
        });
        load();
      });
    });

    var form = root.querySelector("[data-studio-custom]");
    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        var from = form.from && form.from.value;
        var to = form.to && form.to.value;
        if (!from || !to) return;
        root.querySelectorAll("[data-studio-range]").forEach(function (el) {
          el.classList.remove("is-on");
        });
        query = "from=" + encodeURIComponent(from) + "&to=" + encodeURIComponent(to);
        load();
      });
    }

    root.addEventListener("click", function (event) {
      var btn = event.target.closest("[data-studio-pin]");
      if (!btn || !root.contains(btn) || btn.disabled) return;
      var handle = (btn.getAttribute("data-studio-pin") || "").trim().toLowerCase();
      if (!handle) return;
      var next = (root._pinned || []).slice();
      var index = next.indexOf(handle);
      if (index >= 0) next.splice(index, 1);
      else if (next.length < 3) next.push(handle);
      else return;
      root._pinned = next;
      if (root._data) renderDash(root, root._data, sortKey);
      request("/studio", {
        method: "POST",
        headers: { accept: "application/json", "content-type": "application/json" },
        body: JSON.stringify({ handles: next })
      }).then(function (body) {
        if (body && Array.isArray(body.pinned)) root._pinned = body.pinned.slice(0, 3);
        if (root._data) renderDash(root, root._data, sortKey);
      });
    });

    load();
  }

  hydrateHeader();
  bindBeacons();
  bindDash();
})();
